"use strict";

const DEFAULT_RETRY_MAX = 3;
const DEFAULT_RETRY_INTERVAL_SEED = 150;

async function retryAsync(asyncFunc, errorHandler = null, seedInterval = DEFAULT_RETRY_INTERVAL_SEED, maxRetry = DEFAULT_RETRY_MAX, attempt = 0, ) {
    try {
        return await asyncFunc();
    } catch (e) {
        if (errorHandler && errorHandler(e)) {
            return;
        }
        return new Promise((resolve, reject) => {
            if (attempt >= maxRetry) {
                reject(e);
                return;
            }
            const increasedAttempt = ++attempt;
            setTimeout(async function() {
                    try {
                        resolve(await retryAsync(asyncFunc, errorHandler, seedInterval, maxRetry, increasedAttempt));
                    } catch (error) {
                        reject(error);
                    }
                },
                seedInterval * Math.pow(increasedAttempt, 2));
        });
    }
}

export default retryAsync;